// extracted by mini-css-extract-plugin
module.exports = {"centered":"_89b4965636--centered--KLF5u","full-width":"_89b4965636--full-width--d5akD"};